import * as Joi from 'joi-browser';

const schema = Joi.object().keys({
  email: Joi.string()
    .email()
    .required(),
});

export default schema;
